import { render } from "./ArtworkBatchUpdate.vue?vue&type=template&id=d88dcd3c&scoped=true"
import script from "./ArtworkBatchUpdate.vue?vue&type=script&lang=js"
export * from "./ArtworkBatchUpdate.vue?vue&type=script&lang=js"

import "./ArtworkBatchUpdate.vue?vue&type=style&index=0&id=d88dcd3c&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88dcd3c"]])

export default __exports__